module.exports = __webpack_public_path__ + "static/media/ic_checked.340150f0.svg";